import {action, observable, computed} from 'mobx';
import _ from 'lodash';
import moment from 'moment';
import {DomainObject, oneOf} from 'shared/store';
import AnniversaryBonus from './AnniversaryBonus';
import BalanceAdjustmentPolicy from './BalanceAdjustmentPolicy';
import TimeOffType from './TimeOffType';
import User from 'main/stores/users/User';

class TimeOffTypePolicy extends DomainObject {
  @observable id;
  @observable accrualFrequency;
  @observable baseAccrualRate;
  @observable units;
  @observable waitPeriod;
  @observable prorationEnabled;
  @observable anniversaryBonuses;
  @observable balanceAdjustmentPolicy;

  @observable totalAccrualPerYear;
  @observable accrualRate;
  @observable accrualStart;
  @observable accrualStartDate;
  @observable newEffectiveDate;
  @observable accrueUpfront;

  @observable minimumRequestIncrement;
  @observable preventNegativeBalance;

  @observable approvalType;
  @observable secondStageApprovalType;
  @observable firstStageApprovers = [];
  @observable secondStageApprovers = [];

  @action merge(other) {
    super.merge(other, {
      type: TimeOffType,
      anniversaryBonuses: [AnniversaryBonus],
      balanceAdjustmentPolicy: BalanceAdjustmentPolicy,
      secondStageApprovalAssigneeUser: User,
      accrualStart: oneOf([
        'policy_start_date',
        'policy_holder_start_date'
      ]),
      approvalType: oneOf([
        'auto',
        'single',
        'two_stage'
      ]),
      secondStageApprovalType: oneOf([
        'user',
        'manager',
        'managers_manager'
      ]),
      _dates: ['accrualStartDate']
    });
  }

  yearStartForPolicyHolder(policy, employee) {
    switch (this.accrualStart) {
      case 'policy_holder_start_date':
        return moment(employee.startDate).format('MMMM D');
      case 'policy_start_date':
      default:
        return moment(policy.currentYearStartDate).format('MMMM D');
    }
  }

  @computed get sortedAnniversaryBonuses() {
    return _.sortBy(
      this.anniversaryBonuses,
      'anniversary'
    );
  }
}

export default TimeOffTypePolicy;
